import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TagModule } from 'primeng/tag';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AddExpenseService } from '../../../services/add-expense.service';
import { AutocompleteService } from '../../../services/autocomplete.service';
import { ExpenseLookup } from '../../../models/ExpenseLookupModel';
import { LookupItem } from '../../../../global/model/SearchModel';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DialogModule } from 'primeng/dialog';
import { SelectListItem } from '../../../models/SelectListItem';
import { autocompleteSelectionValidator } from '../../../validators/non-async-validators';
import { EntityType } from '../../../models/ConstantsAndEnums';
import { catchError, debounceTime, distinctUntilChanged } from 'rxjs';
import { VendorAddUpdateComponent } from '../../vendor-add-update/vendor-add-update.component';
import { AddUpdateVendorService } from '../../../services/add-update-vendor.service';
import { restrictToTwoDecimals } from '../../../../global/util/util';

@Component({
  selector: 'expense-add-details',
  templateUrl: './expense-add-details.component.html',
  styleUrls: ['./expense-add-details.component.scss'],
  imports: [ButtonModule, CardModule, AutoCompleteModule, DropdownModule, CommonModule, CalendarModule, InputTextModule, InputTextareaModule, TagModule, SelectButtonModule, ToggleButtonModule, ReactiveFormsModule,
    DialogModule, VendorAddUpdateComponent],
  standalone: true,
  providers: [
    ConfirmationService,
    MessageService,
    AddExpenseService,
    AutocompleteService,
    AddUpdateVendorService
  ],
})
export class ExpenseAddDetailsComponent implements OnInit {
  expenseDetailsForm!: FormGroup;
  @Input() campaignId!: number;
  @Input() expenseId!: number;
  @Input() confirmAction!: (
    message: string,
    acceptCallback: () => void,
    rejectCallback?: () => void
  ) => void;
  @Output() nextCallback = new EventEmitter<void>();
  @Output() expenseidSelected = new EventEmitter<number>();
  @Output() expensedetailsSelected = new EventEmitter<any>();
  @Output() errorEvent = new EventEmitter<string>();
  expenselookups: ExpenseLookup = { isEntity: false, vendors: [], fundCodes: [], paymentMethods: [], childCampaigns: [] };
  vendors: SelectListItem[] = [];
  fundcodes: LookupItem[] = [];
  childCampaigns: LookupItem[] = [];
  paymentmethods: LookupItem[] = [];
  checkbookItems: LookupItem[] = [];
  vendorSuggestions: any = [];
  hold: boolean = false;
  showAddVendorMondal: boolean = false;
  onIcon: string = 'pi pi-check';
  isEntity: boolean = false;
  isShowVendor: boolean = false;
  vendorSelected: boolean = false;
  vendorMode: 'add' | 'update' = 'add';
  childCampaignId!: number;
  selectedVendorId!: string;
  expenseStatus: string = 'Unapproved';

  constructor(private fb: FormBuilder, private addExpenseService: AddExpenseService, private vendorService: AddUpdateVendorService, private autoCompleteService: AutocompleteService) { }

  initializeForm() {
    if (this.expenseId > 0) {
      this.addExpenseService.getExpenseDetails(this.expenseId).subscribe({
        next: (details) => {
          console.debug(details);
          this.addExpenseService.getCheckbooksByFundCode(this.campaignId, details.fundCodeId).subscribe({
            next: (checkbooks) => {
              this.checkbookItems = checkbooks;
            },
            error: () => {
              this.errorEvent.emit('Failed to load Checkbooks');
              this.checkbookItems = [];
            }
          });
          this.vendorSuggestions = [{ label: details.vendorName, value: details.vendorId }];
          this.expenseDetailsForm = this.fb.group({
            campaignId: [this.campaignId],
            childCampaignId: [''],
            expenseRequestId: [this.expenseId],
            isEntity: [details.isEntityCampaign],
            vendor: [{ label: details.vendorName, value: details.vendorId }, [Validators.required, autocompleteSelectionValidator(() => this.vendorSuggestions)]],
            vendorId: [details.vendorId, Validators.required],
            fundCodeId: [details.fundCodeId, Validators.required],
            dueDate: [new Date(details.dueDate), Validators.required],
            requestedAmount: [details.requestedAmount, Validators.required],
            calculatedamount: new FormControl({ value: details.calculatedAmount, disabled: true }),
            description: [details.description],
            invoiceDate: details.invoiceDate ? [new Date(details.invoiceDate)] : "",
            invoicenumber: [details.invoiceNumber],
            paymentMethodId: [details.paymentMethodId, Validators.required],
            checkBookId: [details.checkBookId, Validators.required],
            hold: [details.hold]
          });
          this.vendorSelected = true;
          this.vendorMode = 'update' as 'add' | 'update';
          this.childCampaignId = 0;
          this.selectedVendorId = details.vendorId;
          this.expenseStatus = details.expenseStatus;
          this.LoadMappings();
        },
        error: () => {
          this.errorEvent.emit('Failed to load Expense Details');
          this.fundcodes = [];
        }
      });
    }
    else {
      this.LoadMappings()
    }
  }
  ngOnInit(): void {
    this.expenseDetailsForm = this.fb.group({
      campaignId: [''],
      childCampaignId: [''],
      expenseRequestId: [''],
      isEntity: [false],
      vendor: ['', [Validators.required, autocompleteSelectionValidator(() => this.vendorSuggestions)]],
      vendorId: ['', Validators.required],
      fundCodeId: ['', Validators.required],
      dueDate: ['', Validators.required],
      requestedAmount: ['', Validators.required],
      calculatedamount: new FormControl({ value: '', disabled: true }),
      description: [''],
      invoiceDate: [''],
      invoicenumber: [''],
      paymentMethodId: [3, Validators.required],
      checkBookId: ['', Validators.required],
      hold: [false]
    });
    this.initializeForm();
    if (!this.campaignId) return;
  }

  showVendorModal() {
    this.isShowVendor = true;
  }
  LoadMappings() {
    this.expenseDetailsForm.get('campaignId')?.setValue(this.campaignId);
    this.expenseDetailsForm.get('expenseRequestId')?.setValue(this.expenseId);
    this.addExpenseService.getLookups(this.campaignId).subscribe({
      next: (data) => {
        console.debug(data);
        this.expenselookups = data;
        this.childCampaigns = data.childCampaigns;
        this.paymentmethods = data.paymentMethods;
        this.isEntity = data.isEntity;
        this.expenseDetailsForm.get('isEntity')?.setValue(this.isEntity);
        if (!this.isEntity) {
          this.fundcodes = data.fundCodes;
        }

        this.updateCampaignIdValidator();

        // Subscriptions based on isEntity
        if (this.isEntity) {
          this.expenseDetailsForm.get('childCampaignId')?.valueChanges.subscribe(childId => {
            if (childId) {
              this.addExpenseService.getFundCodesByCampaign(childId).subscribe({
                next: (codes) => {
                  this.fundcodes = codes;
                  this.expenseDetailsForm.patchValue({ fundCodeId: null, checkbookId: null });
                  this.checkbookItems = [];
                },
                error: () => {
                  this.errorEvent.emit('Failed to load Fund codes');
                  this.fundcodes = [];
                }
              });
            }
          });
        }

        this.expenseDetailsForm.get('fundCodeId')?.valueChanges.subscribe(fundCodeId => {
          if (fundCodeId) {
            this.addExpenseService.getCheckbooksByFundCode(this.campaignId, fundCodeId).subscribe({
              next: (checkbooks) => {
                this.checkbookItems = checkbooks;
                this.expenseDetailsForm.get('checkBookId')?.reset();
              },
              error: () => {
                this.errorEvent.emit('Failed to load Checkbooks');
                this.checkbookItems = [];
              }
            });
          }
        });

        this.expenseDetailsForm.get('vendor')?.valueChanges.subscribe(fundCodeId => {
          if (fundCodeId.length == 0) {
            this.vendorSelected = false;
            this.selectedVendorId = "";
          }
        });
      }
    });
  }

  closeVendor() {
    this.isShowVendor = false;
    if (this.vendorMode == "add") {
      this.expenseDetailsForm.get('vendorId')?.setValue("");
      this.expenseDetailsForm.get('vendor')?.setValue("");
    }
  }
  updateCampaignIdValidator() {
    const campaignControl = this.expenseDetailsForm.get('childCampaignId');
    if (this.isEntity) {
      campaignControl?.setValidators(Validators.required);
    } else {
      campaignControl?.clearValidators();
    }
    campaignControl?.updateValueAndValidity();
  }

  onSubmit() {
    if (this.expenseDetailsForm.valid) {
      console.debug(this.expenseDetailsForm.value);
      this.addExpenseService.saveExpense(this.expenseDetailsForm.value).subscribe({
        next: (expenseId) => {
          this.expenseId = expenseId;
          this.expenseDetailsForm.get('expenseRequestId')?.setValue(expenseId);
          this.expenseidSelected.emit(expenseId);
          const formData = this.expenseDetailsForm.value;
          this.expensedetailsSelected.emit(formData);
          this.nextCallback.emit();
        },
        error: (errorResponse) => {
          this.errorEvent.emit('Failed to save Expense Details, Error: ' + errorResponse?.error?.Error);
        }
      });
    } else {
      this.markAllAsTouched(this.expenseDetailsForm);
    }
  }

  markAllAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      formGroup.get(field)?.markAsTouched();
    });
  }

  searchVendor(query: string): void {
    if (!query) {
      this.vendorSuggestions = [];
      return;
    }
    this.autoCompleteService.getAutoCompleteResults(query, EntityType.Vendors, this.campaignId).pipe(
      debounceTime(300),
      distinctUntilChanged(),
      catchError(() => [])
    ).subscribe((results) => {
      if (results.length === 0) {
        this.vendorSelected = false;
        this.vendorSuggestions = [{
          label: "Add New Vendor",
          value: "add_new"
        }];
      }
      else {

        var updatedResults = this.mapToLabelValue(results);
        updatedResults.push({
          label: "Add New Vendor",
          value: "add_new"
        });
        this.vendorSuggestions = updatedResults;
        this.expenseDetailsForm.get('vendorId')?.updateValueAndValidity();
      }
    });
  }

  onVendorSelect(vendor: any) {
    if (vendor.value.value === 'add_new') {
      this.childCampaignId = this.expenseDetailsForm.get('childCampaignId')?.value;
      this.isShowVendor = true;
      this.vendorMode = 'add' as 'add' | 'update';;
    }
    else {
      const vendorId = vendor.value.value;
      this.vendorService.getVendor(vendorId, this.campaignId).subscribe({
        next: (newdata) => {
          this.expenseDetailsForm.get('paymentMethodId')?.setValue(newdata.vendorInfo_DefaultPaymentMethodId ?? 3);
        },
        error: () => {
          this.errorEvent.emit('Failed to Get Vendor Details');
        }
      });
      this.expenseDetailsForm.get('vendorId')?.setValue(vendorId);
      this.vendorMode = 'update' as 'add' | 'update';;
      this.selectedVendorId = vendorId;
      this.vendorSelected = true;
    }
  }

  onVendorAddedUpdated(newVendor: { label: string; value: string }) {
    this.isShowVendor = false; // Close the dialog
    this.vendorSuggestions = [newVendor]; // Optionally update suggestions
    this.expenseDetailsForm.get('vendor')?.setValue({ label: newVendor.label, value: newVendor.value });
    this.expenseDetailsForm.get('vendorId')?.setValue(newVendor.value);
    this.vendorService.getVendor(newVendor.value, this.campaignId).subscribe({
      next: (newdata) => {
        this.expenseDetailsForm.get('paymentMethodId')?.setValue(newdata.vendorInfo_DefaultPaymentMethodId ?? 3);
      },
      error: () => {
        this.errorEvent.emit('Failed to Get Vendor Details');
      }
    });
    this.vendorSelected = true;
    this.selectedVendorId = newVendor.value;
    this.vendorMode = "update";
  }

  private mapToLabelValue(items: any[]): { label: string, value: string }[] {
    return items?.map((item: any) => ({ label: item.text, value: item.value })) || [];
  }

  getSeverityAndValue(status: string): { severity: 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast', value: string } {
    let severity: 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast' = 'secondary'; // default value 
    let value = status;
    switch (status) {
      case 'Unapproved':
        severity = "danger";
        value = 'Unapproved';
        break;
      case 'Partial':
        severity = 'warning';
        value = 'Partial';
        break;
      case 'Approved':
        severity = 'success';
        value = 'Approved';
        break;
      case 'Paid':
        severity = 'info';
        value = 'Paid';
        break;
      default:
        severity = 'secondary';
        value = 'Unknown';
    }

    return { severity, value };
  }

  onSaveExpense(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.expenseDetailsForm.valid) {
        console.debug(this.expenseDetailsForm.value);
        this.addExpenseService.saveExpense(this.expenseDetailsForm.value).subscribe({
          next: (expenseId) => {
            this.expenseId = expenseId;
            this.expenseDetailsForm.get('expenseRequestId')?.setValue(expenseId);
            this.expenseidSelected.emit(expenseId);
            const formData = this.expenseDetailsForm.value;
            this.expensedetailsSelected.emit(formData);
            resolve(true);
          },
          error: (errorResponse) => {
            this.errorEvent.emit('Failed to save Expense Details, Error: ' + errorResponse?.error?.Error);
            resolve(false);
          }
        });
      } else {
        this.markAllAsTouched(this.expenseDetailsForm);
        resolve(false);
      }
    });
  }

  onAmountInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = restrictToTwoDecimals(input.value);
    this.expenseDetailsForm.get('requestedAmount')?.setValue(input.value, { emitEvent: false });
  }
}
